
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

import { Nav } from "react-bootstrap";

import bg from "assets/img/expedited-trucking.jpeg";
import logo from "assets/img/logo.png";
import { buildPermissionSet, hasRoutePermission } from "utils/pageAccess";

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const navigator = useSelector((state) => state.navigation);
  const userPermissions = navigator.user.data?.user.user_permissions || [];
  const userPermissionSet = buildPermissionSet(userPermissions);

  return (
    <div className="sidebar" data-image={bg} data-color={color}>
      <div
        className="sidebar-background"
        style={{
          backgroundImage: "url(" + bg + ")"
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            href="#"
            className="simple-text logo-mini mx-1"
          >
            <img src={logo} style={{ width: 150 }} alt="..." />
          </a>
        </div>
        <Nav>
          {routes.map((prop, key) => {
            const hasPermission = hasRoutePermission(prop, userPermissionSet);

            if (!prop.redirect && !prop.hide && hasPermission)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
